import React, { useEffect, useState } from "react";
import './AuthorDetails.css';
import artwork_example from './images/artwork_details_example.png'
import artist_example from './images/LucyNelson.png'
import Slider from "react-slick";
import DiscoveryArtworkCardView from "./DiscoveryArtworkCardView";
import { Layout, Button, Image } from "antd";
import ProPortalHeader from "../componets/ProPortalHeader";
import ProfileRow from "../componets/ProfileRow";
import Navigator from "../componets/Navigator";
import { Content } from "antd/es/layout/layout";
import { useLocation } from 'react-router-dom';
import { get_api, post_api } from "../serverTemp";
import { useNavigate } from "react-router-dom";

const ArtworkCard = (props) => {
    const navigate = useNavigate();
    const [isInCart, setIsInCart] = useState(false);
    const [isInLibrary, setIsInLibrary] = useState(false);
    // const [minWidthRestrict, setMinWidthRestrict] = useState((props.artwork.height < props.artwork.width) ? {minWidth: "360px"} : {})

    const handleClick = (param) => {
        // console.log("adding cart")
        // console.log(param)
        if (!isInCart) {
            post_api('/shopping/cart/add/sku', { ...param })
                .then(res => {
                    setIsInCart(true)
                })
        } else {
            post_api('/shopping/cart/remove/sku', { ...param })
                .then(res => {
                    setIsInCart(false)
                })
        }
    }

    const addToLibrary = () => {
        if (!isInLibrary) {
            post_api('/album/add/artwork', { id: "default", artwork_ids: [props.artwork.id], from_: props.artwork.from_ })
                .then(res => {
                    setIsInLibrary(true)
                })
        } else {
            // navigate('/proportal/images',
            //     {
            //         state: {
            //             filter: (props.artwork.height > props.artwork.width) ? 1 : 0,
            //             title: (props.artwork.height > props.artwork.width) ? 'Portrait Images' : 'Landscape Images'
            //         }
            //     })

            navigate('/proportal/images',
                {
                    state: {
                        filter: 2,
                        title: 'My Vieunite Art',
                        myArtMode: true
                    }
                })
        }
    }

    const previewOnCanvas = (param) => {
        // console.log("preview");
        // console.log(param);
        // { artwork_id: props.artwork.id, isPreview: true, from_: props.artwork.from_ }
        navigate('/proportal/dashboard', { state: param });
    }

    const premiumHeightConstraint = ((props.artwork.height > props.artwork.width) ? { minHeight: "360px" } : {})
    const basicHeightConstraint = ((props.artwork.height > props.artwork.width) ? { minHeight: "368px" } : {})

    return (
        <div className="product-detail-container" style={{ margin: "30px" }}>
            <div className="author-details-author-avatar">
                {console.log("avatar loading")}
                {console.log(props.artwork.url)}
                <Image style={{ maxHeight: "100%", maxWidth: "100%" }} src={props.artwork.url} alt="artwork" />
            </div>
            <div className="artwork-info-description-section">
                {/* {console.log("isPortrait")} */}
                {/* {console.log({isPortrait}) } */}
                <div className="artwork-info-description-text-section" style={localStorage.getItem('subscription') === "Standard" ? basicHeightConstraint : premiumHeightConstraint}>
                    <p className="author-details-product-title">{props.artwork.name}</p>
                    <p className="author-details-description-title">Description:</p>
                    <p className="author-details-description-body">{props.artwork.description}</p>
                    <p className="author-details-price-tag"> {localStorage.getItem('subscription') !== "Standard" ? "" : "£" + (props.artwork.price)} </p>
                </div>

                {/* style={{ display: "flex", flexDirection: "column", marginTop: "50px", justifyContent: "center", alignItems: "end" }} */}
                {localStorage.getItem('subscription') !== "Standard" ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Button className="button-preview" onClick={() => previewOnCanvas({ artwork_id: props.artwork.id, isPreview: true, from_: props.artwork.from_ })}>Preview it on Textura</Button>
                        <Button className="button-add" onClick={() => addToLibrary()}> {isInLibrary ? ("View Album") : ("Save to My Library")}</Button>
                        <Button className="button-add" onClick={() => previewOnCanvas({ artwork_id: props.artwork.id, isPreview: false, from_: props.artwork.from_ })}> Send to Textura</Button>
                    </div>
                ) : (
                    <div>
                        <p className="membership-promo"> <span className="membership-link">Upgrade to Standard membership</span> and display it for Free</p>
                        <Button className="button-preview" onClick={() => previewOnCanvas({ artwork_id: props.artwork.id, isPreview: true, from_: props.artwork.from_ })}>Preview it on Textura</Button>
                        {console.log("show me the price")}
                        {console.log(props.artwork.price)}
                        {props.artwork.price !== 0 ? (
                            <Button className="button-add" onClick={() => handleClick({ sku_id: props.artwork.id, sku_type: 0 })} style={{ backgroundColor: isInCart ? '#A06174' : '#0E487A' }}> {isInCart ? 'Added' : 'Add to bag'} </Button>
                        ) : (
                            <Button className="button-add" onClick={() => addToLibrary()}> {isInLibrary ? ("View Album") : ("Save to My Library")}</Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const AuthorCard = (props) => {
    const navigate = useNavigate();
    const openArtistDetails = (param) => {
        console.log("click on artist")
        navigate('/proportal/discover-art/author-details', { state: { pageType: "artist", info: { artist: param } } })
    }
    return (
        <div className="author-detail-container" style={{ background: "#F4F4F4" }}>
            <div className="product-image">
                <img src={props.author.url} alt="author name" onClick={() => openArtistDetails(props.author)} style={{ width: "200px", height: "200px", cursor: "pointer" }} fallback="data:image/png;base64,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" />
            </div>
            <div className="product-info">
                <p className="artist-bio-title" onClick={() => openArtistDetails(props.author)}>{props.author.name}</p>
                <p className="artist-bio-body">{props.author.description}</p>
            </div>
        </div>
    );
};

const TagSection = (props) => {
    console.log(props)
    const tagList = props.tags.split(',')
    return (
        <div style={{ background: "#F4F4F4", margin: "30px" }}>
            <p className="product-description-title">Tags</p>
            <div>
                {tagList.map((item, index) => (
                    // <Button className="button-tag"> {item} </Button>
                    <span className="button-tag"> #{item} </span>
                ))}
            </div>
        </div>
    );
};

// const artworks = [
//     {
//         "id": "54647654534",
//         "name": "All at Sea",
//         "description": "What a beautiful sea and living creatures in the sea!",
//         "artistName": "Ke Yang",
//         "url": "http://api.vieunite.com/ng/files/1579488114120876033/7ad5a0ccbb584a62ad8f2dad02bf6f7c.jpeg",
//         "width": 1080,
//         "height": 1920,
//         "price": 13,
//         "tags": "Fine Art,fine art genre1,tag1,tag2",
//         "createTime": "2023-11-21 16:06:49",
//         "artist": {
//             "id": "342865913238791",
//             "name": "Jo Vincent",
//             "description": "I am the greatest artist",
//             "url": "https://raw.githubusercontent.com/purnakar18/Biophilic_survey/main/images/Awe/Chicago_image_1026.jpg"
//         }
//     },
//     {
//         "id": "54647654534",
//         "name": "All at Sea",
//         "description": "What a beautiful sea and living creatures in the sea!",
//         "artistName": "Ke Yang",
//         "url": "http://api.vieunite.com/ng/files/1579488114120876033/7ad5a0ccbb584a62ad8f2dad02bf6f7c.jpeg",
//         "width": 1080,
//         "height": 1920,
//         "price": 13,
//         "tags": "Fine Art,fine art genre1,tag1,tag2",
//         "createTime": "2023-11-21 16:06:49",
//         "artist": {
//             "id": "342865913238791",
//             "name": "Jo Vincent",
//             "description": "I am the greatest artist",
//             "url": "https://raw.githubusercontent.com/purnakar18/Biophilic_survey/main/images/Awe/Chicago_image_1026.jpg"
//         }
//     },
//     {
//         "id": "54647654534",
//         "name": "All at Sea",
//         "description": "What a beautiful sea and living creatures in the sea!",
//         "artistName": "Ke Yang",
//         "url": "http://api.vieunite.com/ng/files/1579488114120876033/7ad5a0ccbb584a62ad8f2dad02bf6f7c.jpeg",
//         "width": 1080,
//         "height": 1920,
//         "price": 13,
//         "tags": "Fine Art,fine art genre1,tag1,tag2",
//         "createTime": "2023-11-21 16:06:49",
//         "artist": {
//             "id": "342865913238791",
//             "name": "Jo Vincent",
//             "description": "I am the greatest artist",
//             "url": "https://raw.githubusercontent.com/purnakar18/Biophilic_survey/main/images/Awe/Chicago_image_1026.jpg"
//         }
//     },
//     {
//         "id": "54647654534",
//         "name": "All at Sea",
//         "description": "What a beautiful sea and living creatures in the sea!",
//         "artistName": "Ke Yang",
//         "url": "http://api.vieunite.com/ng/files/1579488114120876033/7ad5a0ccbb584a62ad8f2dad02bf6f7c.jpeg",
//         "width": 1080,
//         "height": 1920,
//         "price": 13,
//         "tags": "Fine Art,fine art genre1,tag1,tag2",
//         "createTime": "2023-11-21 16:06:49",
//         "artist": {
//             "id": "342865913238791",
//             "name": "Jo Vincent",
//             "description": "I am the greatest artist",
//             "url": "https://raw.githubusercontent.com/purnakar18/Biophilic_survey/main/images/Awe/Chicago_image_1026.jpg"
//         }
//     }
// ]

const AuthorDetails = (props) => {
    const [artworks, setArtworks] = useState([]);
    const navigate = useNavigate();
    const openArtistDetails = (param) => {
        console.log("read param")
        console.log(param)

        // {
        //     "id": "1667121116509411249",
        //     "name": "Art Institute of Chicago",
        //     "description": "This gallery features a curated collection of classic style art, with unrestricted access to masterpieces that evoke technical mastery, and profound emotional impact.\nWe have partnered with renowned galleries, granting you exclusive access to their exceptional treasures. Choose a piece that resonates with you, and bring its timeless allure into your home. \nLet our gallery become your source of inspiration, elevating your surroundings with the power of artistry.\n",
        //     "url": "https://api.vieunite.com/ng/defaultImg/searchCategory/gallery.webp",
        //     "official_website": ""
        // }

        // if (!param.official_website) {
        //     navigate('/proportal/discover-art/author-details', { state: { pageType: "artist", info: { artist: param } } })
        // } else {
        //     navigate('/proportal/discover-art/gallery-details', { state: { gallery: param } })
        // }

        navigate('/proportal/discover-art/author-details', { state: { pageType: "artist", info: { artist: param } } })
    }
    const onBack = () => {
        navigate('/proportal/discover-art')
    }
    const { pageType, info } = props.item.state

    useEffect(() => {
        get_api(`/artist/artworks?artist_id=${info.artist.id}`).then(res => {
            console.log("test");
            console.log(res.data);
            setArtworks(res.data);
        });
    }, [])

    // {
    //     "id": "1",
    //     "name": "Sun",
    //     "description": "Sun!",
    //     "artistName": "I am who I am",
    //     "url": "https://gospelproject.lifeway.com/wp-content/uploads/tgp2018/2021/11/4_3_God_Delivered_His_People.jpg",
    //     "width": 720,
    //     "height": 465,
    //     "price": 13.00,
    //     "tags": "tag1,tag2",
    //     "createTime": "2023-11-21 16:06:49",
    //     "artist": {
    //         "id": "1",
    //         "name": "I am who I am",
    //         "description": "King of kings",
    //         "url": "https://gospelproject.lifeway.com/wp-content/uploads/tgp2018/2021/11/4_3_God_Delivered_His_People.jpg"
    //     }
    // }

    var sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        nextArrow: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.32977 36.6463C0.353459 37.6226 0.353459 39.2055 1.32977 40.1818C2.30608 41.1581 3.88899 41.1581 4.8653 40.1818L14.4377 30.6094L24.0101 21.0371L23.9733 21.0003L24.1172 20.8564L4.97243 1.71161C3.99612 0.735296 2.41321 0.735296 1.4369 1.71161C0.460586 2.68792 0.460586 4.27083 1.4369 5.24714L17.0829 20.8932L10.9022 27.0739L1.32977 36.6463Z" fill="#0E487A" />
        </svg>,
        prevArrow: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.6761 36.6463C24.6524 37.6226 24.6524 39.2055 23.6761 40.1818C22.6998 41.1581 21.1169 41.1581 20.1406 40.1818L10.5682 30.6094L0.995795 21.0371L1.03258 21.0003L0.88867 20.8564L20.0334 1.71161C21.0097 0.735296 22.5927 0.735296 23.569 1.71161C24.5453 2.68792 24.5453 4.27083 23.569 5.24714L7.92295 20.8932L14.1037 27.0739L23.6761 36.6463Z" fill="#0E487A" />
        </svg>,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div style={{ background: "#F4F4F4", minHeight: "100vh", marginBottom: "40px", marginTop: "15px" }}>
            <p className="navigation-bar-title">
                <span style={{ cursor: 'pointer' }} onClick={onBack}> &lt; Discover Art &nbsp;</span>
                <span onClick={() => openArtistDetails(info.artist)} style={{ cursor: 'pointer' }}>/  {info.artist.name} /</span>
                <span>&nbsp; {info.name}</span>
            </p>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
                {pageType === "artwork" && (
                    <ArtworkCard artwork={info} />
                )}
                <AuthorCard author={info.artist} />
            </div>

            {pageType === "artwork" && info.tags && info.tags.length > 0 && (
                <TagSection tags={info.tags} />
            )}

            <p className='collection-title' style={{ margin: "30px" }}> Other work by {info.artist.name} </p>
            {artworks.length !== 0 && (
                <Slider {...sliderSettings} style={{ marginLeft: "35px", marginRight: "35px" }}>
                    {artworks.map((item, index) => (
                        <div key={index}>
                            <DiscoveryArtworkCardView item={item} />
                        </div>
                    ))}
                </Slider>
            )}
            {/* <p style={{ margin: "30px" }}>  </p> */}

        </div>
    );
};

const AuthorDetailsWrap = () => {
    const state = useLocation()
    return (
        <Layout>
            <Content>
                <ProPortalHeader />
                <ProfileRow />
                <Layout>
                    <Navigator />
                    <Layout>
                        <AuthorDetails item={state} />
                    </Layout>
                </Layout>
            </Content>
        </Layout>
    );
};

export default AuthorDetailsWrap;